import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  ArrowRight,
  CheckCircle,
  ChevronRight,
  LineChart,
  Linkedin,
  Lock,
} from "lucide-react";
import "./CareerGrowth.css";
import API_URL from "../../config";
import { ErrorNotification } from "../../tosterNotification/tosters";

const milestones = [
  {
    id: "Milestone 1",
    title: "Level 1",
    description: "Level 1",
    color: "#6600CC",
    unlocked: true,
  },
  {
    id: "Milestone 2",
    title: "Level Up",
    description: "Level Up",
    color: "#148687",
    unlocked: false,
  },
  {
    id: "Milestone 3",
    title: "Gear Up",
    description: "Gear Up",
    color: "#637311",
    unlocked: false,
  },
  {
    id: "Milestone 4",
    title: "Go Pro",
    description: "Go Pro",
    color: "#650A17",
    unlocked: false,
  },
];

const CareerGrowth = () => {
  const [selectedProgram, setSelectedProgram] = useState("soft_skills");
  const [milestoneData, setMilestoneData] = useState({});
  const [selected_milestone, setSelected_milestone] = useState("Milestone 1");
  const location = useLocation();
  const userId = location.state?.user;
  const userName = location.state?.userName;

  const programs = [
    { id: "soft_skills", icon: "👥", label: "Soft Skills" },
    // { id: "core_technical", icon: "🚀", label: "Core Skills" },
    { id: "digital_fluency", icon: "⚒️", label: "Digital Fluency" },
    { id: "networking", icon: "🌐", label: "Networking" },
    // { id: "profile_building", icon: <Linkedin />, label: "Profile Building" },
    { id: "activities", icon: <LineChart />, label: "Activity" },
  ];

  useEffect(() => {
    const fetchMilestoneData = async () => {
      const response = await fetch(`${API_URL}/api/mileStone/getMileStones`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ userId }),
      });
      const data = await response.json();
      setMilestoneData(data.data["Milestone 1"]);
    };
    fetchMilestoneData();
  }, [userId]);

  const getCurrentMilestoneData = () => {
    const milestone = milestoneData.skills;
    return milestone?.[selectedProgram] || [];
  };

  const handleMilestoneClick = ({ milestone }) => {
    if (!milestone.unlocked) {
      ErrorNotification("This milestone is locked for user !");
      setSelected_milestone("Milestone 1");
      return;
    }
  };

  const RenderProgramView = () => {
    const mergedData = getCurrentMilestoneData();
    return (
      <div className="w-auto">
        {mergedData?.map((item, _idx) => (
          <div key={_idx} className="mb-2">
            <div className="shadow-sm border rounded-3">
              <div className="d-flex p-3 gap-3 flex-column flex-sm-row align-items-center text-center text-sm-start">
                <img
                  src="course_image.png"
                  alt="course"
                  className="img-fluid"
                  style={{
                    width: "9rem",
                    height: "7rem",
                    borderRadius: "8px",
                    objectFit: "fit",
                  }}
                />
                <div className="w-100">
                  <h6
                    className="fw-bold"
                    style={{ fontSize: "14px", color: "#6600cc" }}
                  >
                    {selectedProgram === "activities"
                      ? item.activity_name
                      : item.course_name}
                  </h6>
                  <div className="d-flex flex-column flex-sm-row justify-content-between mt-2 mx-5">
                    <div style={{ fontSize: "12px" }} className="text-black">
                      <span>Language: </span>
                      <span className="fw-semibold">
                        {item.language || "English"}
                      </span>
                    </div>
                    <div style={{ fontSize: "12px" }} className="text-black">
                      <span>
                        {selectedProgram === "activities"
                          ? "Duration"
                          : "Level"}
                        :{" "}
                      </span>
                      <span className="fw-semibold">
                        {selectedProgram === "activities"
                          ? item.estimated_time
                          : item.toughness_level}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  };

  return (
    <div className="container-fluid">
      {Object.keys(milestoneData).length === 0 ? (
        <div className="text-center mt-5">
          <h4>Career path for this user was not generated</h4>
        </div>
      ) : (
        <>
          <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mb-4">
            <h2 className="text-capitalize text-black text-center text-md-start">
              {userName}'s Career Path
            </h2>
          </div>

          <div className="milestone-container">
            <div className="d-flex flex-wrap justify-content-center align-items-center gap-2 mb-4">
              {milestones.map((m, _idx) => (
                <React.Fragment key={_idx}>
                  <div
                    className="border shadow cursor-pointer rounded-4"
                    onClick={() => {
                      handleMilestoneClick({ milestone: m });
                    }}
                  >
                    <div
                      className={`px-3 rounded-4 py-3 d-md-flex flex-row justify-content-center align-items-center gap-2 ${selected_milestone === m.id ? "btn-primary" : ""}`}
                      style={{ height: "100px", width: "200px" }}
                    >
                      <div
                        style={{
                          backgroundColor: m.color,
                          color: "#fff",
                          borderRadius: "50%",
                          height: "40px",
                          width: "40px",
                        }}
                        className={`d-flex align-items-center justify-content-center p-2`}
                      >
                        {m.unlocked ? (
                          <CheckCircle size={28} />
                        ) : (
                          <Lock size={28} />
                        )}
                      </div>
                      <div>
                        <p
                          className={`mb-0 fw-bold ${selected_milestone === m.id ? "text-white" : "text-black"}`}
                          style={{ fontSize: "20px" }}
                        >
                          {m.title}
                        </p>
                        <p
                          className={`mb-0 d-flex justify-content-center fw-semibold ${selected_milestone === m.id ? "text-white" : "text-black"}`}
                          style={{ fontSize: "13px" }}
                        >
                          {m.description}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="mt-n4">
                    {_idx !== milestones.length - 1 && (
                      <ArrowRight size={16} color="#000" />
                    )}
                  </div>
                </React.Fragment>
              ))}
            </div>

            <div className="row g-3 ms-4 p-3">
              <div className="col-12 col-md-3 col-lg-3 mb-3">
                <div className="d-flex flex-row flex-md-column overflow-auto">
                  {programs.map((program) => (
                    <button
                      key={program.id}
                      className={`btn mb-2 d-flex align-items-center gap-2 shadow-sm ${
                        selectedProgram === program.id
                          ? "btn-primary"
                          : "btn-light"
                      }`}
                      style={{ height: "3rem" }}
                      onClick={() => setSelectedProgram(program.id)}
                    >
                      <span>{program.icon}</span>
                      <span className="text-capitalize">{program.label}</span>
                      <ChevronRight className="ms-auto" size={28} />
                    </button>
                  ))}
                </div>
              </div>

              <div className="col-12 col-md-9 col-lg-7">
                <RenderProgramView />
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default CareerGrowth;
